module.exports = __webpack_public_path__ + "img/register-v2.a02ada03.svg";